export default __webpack_public_path__ + "static/media/spinner_cmx.a21c9b1f.svg";